export default class CDNCacheKey {
    static LS_KEY_CDN_CACHE_KEY = '__isp_cdn_cache_key_1';
    static LS_KEY_CDN_CACHE_KEY_EXPIRATION = '__isp_cdn_cache_key_expiration';
    static getCDNCacheKey() {
        const expirationDate = localStorage?.getItem(CDNCacheKey.LS_KEY_CDN_CACHE_KEY_EXPIRATION)?.toString() ?? '';
        const cacheKey = localStorage?.getItem(CDNCacheKey.LS_KEY_CDN_CACHE_KEY)?.toString() ?? '';
        if (cacheKey && expirationDate && parseInt(expirationDate, 10) >= Date.now()) {
            return Number(localStorage.getItem(CDNCacheKey.LS_KEY_CDN_CACHE_KEY));
        }
        return String(Date.now());
    }
    static setCDNCacheKey(key) {
        localStorage.setItem(CDNCacheKey.LS_KEY_CDN_CACHE_KEY, String(key));
        localStorage.setItem(CDNCacheKey.LS_KEY_CDN_CACHE_KEY_EXPIRATION, String(new Date().getTime() + 3600000));
    }
}
//# sourceMappingURL=cdnCacheKey.js.map